import { render, staticRenderFns } from "./ContattoSito.vue?vue&type=template&id=36c8a538&"
import script from "./ContattoSito.vue?vue&type=script&lang=js&"
export * from "./ContattoSito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports